<template>
    <div class="type-content">
        <van-grid :gutter="15" :border=false class="home-type-grid">
            <van-grid-item v-for="(item, value) in categoryVos" :key="value" class="grid-item" @click="getTeachByType(item)">
                <template v-if="item.image != null && item.image != ''">
                    <img :src="item.image" class="home-type-img" />
                </template>
                <template v-else>
                    <img src="../assets/image/home-type-icon.png" class="home-type-img" />
                </template>
                <div class="home-type-text">{{ item.name }}</div>
            </van-grid-item>
        </van-grid>
    </div>
</template>

<script>
import { listCategory } from '@/api/common'   //路径
export default {
  name: 'AllTeachTypePage',
  props: {
    data: {
      type: Object
    },
  },
  data() {
    return {
      categoryVos: [],
      merchantId: ''
    }
  },
  mounted() {
    this.merchantId = this.data.merchantId;
    this.getHomeInfo(this.merchantId);
  },

  methods: {
    getHomeInfo(id) {
      let params = {
        'merchantId': id,
        'parentId': 0,
      };
      listCategory(params).then((res) => {
        this.categoryVos = res.rows; 
      })
    },
    getTeachByType(item) {
      this.$router.push({
          path: '/home/' + this.merchantId, query: {
            value: 'searchPage',
            type: '1',  // 0：首页搜索 1：分类搜索
            searchText: '',
            categoryId: item.id,
            title: item.name
          }
        });
    }
  }

}
</script>
<style scoped>

.type-content {
  padding: 20px 10px;
  height: calc(100vh - 90px);
  overflow-y: auto;
}

.home-type-img {
  margin-bottom: 10px;
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 10px;
}

.home-type-text {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #333333;
  text-align: center;
  font-weight: 400;
}

.grid-item {
    padding: 0 !important;
    height: 71px;
}

.home-type-grid {
    padding: 0 !important;
}

::v-deep .van-grid-item__content {
    padding: 0 !important;
}
</style>
